// extracted by mini-css-extract-plugin
export default {"content":"InfoPurchase_content__EAdKe","finalize_order_details":"InfoPurchase_finalize_order_details__UOow7","info_card":"InfoPurchase_info_card__v4nRj"};